import { render, staticRenderFns } from "./Module4.vue?vue&type=template&id=563bead8&"
import script from "./Module4.vue?vue&type=script&lang=js&"
export * from "./Module4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports